import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

export default function SuccessPage() {
  const navigate = useNavigate();

  useEffect(() => {
    // The return from Stripe does not prove the payment succeeded: the order is confirmed on My Orders
    toast.info("Payment received. We are confirming your order.");

    // Optional: Redirect after a few seconds
    const timer = setTimeout(() => {
      navigate(-1);
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="p-4">
      <h2 className="text-green-600 text-xl font-bold">Payment received</h2>
      <p className="mt-2">Thank you for your payment. We are confirming your order; you can check its status on My Orders.</p>
      <Link to="/my-orders" className="mt-3 inline-block text-blue-600 hover:underline">My Orders</Link>
    </div>
  );
}
